import { render, staticRenderFns } from "./BalanceItem.vue?vue&type=template&id=e0acf4d6&scoped=true&"
import script from "./BalanceItem.vue?vue&type=script&lang=js&"
export * from "./BalanceItem.vue?vue&type=script&lang=js&"
import style0 from "./BalanceItem.vue?vue&type=style&index=0&id=e0acf4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0acf4d6",
  null
  
)

export default component.exports